import { DrawApi } from '@apply/api';
import { IDashboardDrawBudget } from '@apply/api/src/api/DrawApi';
import { DrawAddressLink } from './DrawAddressLink';
import { ResignDrawButton } from './ResignDrawButton';
import { useNavigate } from 'react-router';
import { isMobileScreen } from '@apply/ui';

interface ResignDrawCardProps {
    dashboardDrawBudget: IDashboardDrawBudget;
    set_modalDashboarDrawBudget: React.Dispatch<React.SetStateAction<DrawApi.IDashboardDrawBudget | undefined>>;
}

export const ResignDrawCard: React.FC<ResignDrawCardProps> = ({ dashboardDrawBudget, set_modalDashboarDrawBudget }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (isMobileScreen()) {
            navigate(`/mobilereviewandsubmit/${dashboardDrawBudget.drawBudgetId}`);
        } else {
            navigate(`/draw/${dashboardDrawBudget.drawBudgetId}`);
        }
    };
    return (
        <div className='row draw-pending-container'>
            <DrawAddressLink
                dashboardDrawBudget={dashboardDrawBudget}
                set_modalDashboarDrawBudget={set_modalDashboarDrawBudget}
            />
            <div className='draw-pending-button'>
                <ResignDrawButton handleClick={handleClick} />
            </div>
        </div>
    );
};
